/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum excludeEnum {
    NONE = 'none',
    PLAN = 'plan',
    POOL = 'pool',
    GRANT = 'grant',
}